// extracted by mini-css-extract-plugin
export const list__element = "nav-module--list__element--bBdSR";
export const nav = "nav-module--nav--1LQ0b";
export const yellow__background = "nav-module--yellow__background--2iosQ";
export const navbarItem = "nav-module--navbar-item--1wpLx";
export const wrapper = "nav-module--wrapper--6nnBc";
export const navbar__custom = "nav-module--navbar__custom--1WhYx";